import axios from "@axios";

export default {
  loadOndontogramas() {
    return axios.get(`/profissional/atendimento/odontograma/`);
  },
  generate(data) {
    return axios.post("/profissional/atendimento/odontograma/gerar/", data);
  },
  editTooth(data) {
    return axios.put(`/profissional/atendimento/odontograma/${data.id}`, data);
  },
  getById(id) {
    return axios.get(`/profissional/atendimento/odontograma/${id}`);
  },
  getPatientById(id) {
    return axios.get(`/profissional/atendimento/odontograma/paciente/${id}`);
  },
  getStatus() {
    return axios.get("/profissional/atendimento/odontograma_status/lista");
  },
};
